import { z } from "zod";
/**
 * What a hard-floor supplied & installed price includes, and what it costs per manufacturer (Jacky, 25 Oct 2026).
 *
 * *"I am going to set out underlay & scotia are inclusive matching SQM floor without cut wastage | Trims will no longer
 * be inclusive item … also moisture barrier are not inclusive, as optional … remember every manufacturer has different
 * underlay and scotia prices"*, and scotia at *"1 LM per m²"*.
 *
 * One row per manufacturer (the catalogue `supplier_name`) and category. Underlay applies to floating methods only;
 * `underlay_m2: 0` means attached or not used, `null` means not known yet. A product whose row is missing or unknown has
 * no estimator cost (its GM reads "accessory cost missing") — never a guessed figure. Ex GST, per m² of floor / per LM.
 */
const money = z.number().finite().nonnegative().max(1000).nullable();
export const PriceMyFloorInclusionsSchema = z.object({
    scotia_lm_per_m2: z.number().finite().nonnegative().max(5),
    rows: z.array(z.object({
        supplier: z.string().trim().min(1).max(120),
        category: z.string().trim().min(1).max(60),
        underlay_m2: money,
        scotia_lm: money,
        note: z.string().trim().max(300).default(""),
    })).max(400),
});
export const PriceMyFloorInclusions = {
    kind: "price_my_floor_inclusions",
    version: 1,
    title: "Price my floor — included accessories",
    description: "Underlay (floating floors) and scotia included in a hard floor's supplied & installed price, per manufacturer and category, ex GST. Trims and moisture barrier are optional, not included.",
    radius: 2,
    schema: PriceMyFloorInclusionsSchema,
    defaults: { scotia_lm_per_m2: 1, rows: [] },
};
//# sourceMappingURL=price-my-floor-inclusions.js.map